// Default Base URL
const baseUrl = window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
    process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL;

// Call latest pool temperature endpoints
export async function GetLatestPoolTemperatures() {        
    // Retreive lastest pool temperatures.
    var result;

    await fetch(baseUrl + "environment/latest-pool-temperatures", {
        method: "GET"
    })
    .then(response => response.json())
    .then(response => {
        result = response;
    })
    .catch(error => console.log(error));

    return result;
}